import { NotificationType } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultSeatPickerNotificationConfig = {
    show: true,
    style: NotificationType.Warning,
    displayInline: true
};
export const seatPickerNotificationConfigValidator = Validator.object({
    show: Validator.boolean(),
    style: Validator.oneOf(Object.values(NotificationType)),
    displayInline: Validator.boolean()
});
